<template>
  <Modal :title="title" :showModal="showModal" class="edit-token-form" @submit="submit">
    <template v-slot:body>
      <div class="row">
        <div class="position-relative form-group col-12">
          <label class="col-12 mb-0 p-0">Name*</label>
          <input class="form-control mt-2" type="text" :value="data.name" @change.stop.prevent="store.commit('name', $event.target.value)" />
        </div>
      </div>
      <component v-if="modal" :is="modal" :config="modalConfig()" @close="$emit('close', $event)"></component>
    </template>
  </Modal>
</template>

<script>
import Event from '@/helper/event.js'

export default {
  mixins: [Event],
  data() {
    return {
      modal: false
    }
  },
  computed: {
    title() {
      return 'Edit Token'
    },
    action() {
      return 'edit'
    },
    storeId() {
      return this.config?.storeId
    },
    tokenId() {
      return this.config?.data?._id
    },
    getUri() {
      return `token/get/${this.tokenId}`
    },
    submitUri() {
      return `token/update/${this.tokenId}`
    },
    data() {
      return this.store.getter('', {})
    }
  },
  created() {
    this.store.commit('', {})
  },
  methods: {
    modalConfig() {
      return {
        data: this.data,
        action: this.action,
        storeId: this.storeId,
        tokenId: this.tokenId
      }
    },
    setUpData(rawData) {
      if (rawData.status == 'success') {
        let platform = _.pascalCase(rawData.data.platform || '')
        let action = _.pascalCase(this.action)
        let modal = `${platform}.Token.${action}`
        if (this.$options.components[modal] == undefined) {
          this.$options.components[modal] = this.$util.requireOrNull(`/platforms/${platform}/Token/Modal/${action}.vue`)
        }
        if (!_.isUndefined(rawData.data.platform) && this.$options.components[modal] !== null) {
          this.showModal = true
          this.store.commit('', rawData.data)
          this.modal = modal
        } else {
          this.$emit('close')
          this.$util.notify({
            text: 'Platforms not supported!',
            status: 'error'
          })
        }
      }
    },
    submit() {
      this.submitForm(this.data, {
        done: () => {
          this.$emitter.emit('TableList.Refresh')
          this.$emit('closeAll')
        }
      })
    }
  },
  props: {
    config: Object
  }
}
</script>
